import ReactDOM from 'react-dom';

export interface PortalProps {
  children?: ReactNode;
  container?: Element | DocumentFragment;
}

export default function Portal({ children, container = document.body }: PortalProps) {
  return ReactDOM.createPortal(children, container);
}
